<mat-dialog-content>
  <app-document-template-table
    [data]="data"
    (useTemplate)="close()"
  ></app-document-template-table>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button
          color="accent"
          mat-dialog-close>Close
  </button>
</mat-dialog-actions>
